import { render, staticRenderFns } from "./ChatSystemBox.vue?vue&type=template&id=1949f9f5&scoped=true"
import script from "./ChatSystemBox.vue?vue&type=script&lang=js"
export * from "./ChatSystemBox.vue?vue&type=script&lang=js"
import style0 from "./ChatSystemBox.vue?vue&type=style&index=0&id=1949f9f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949f9f5",
  null
  
)

export default component.exports